import { render, staticRenderFns } from "./ArrowButton.vue?vue&type=template&id=90795f10&scoped=true&"
import script from "./ArrowButton.vue?vue&type=script&lang=js&"
export * from "./ArrowButton.vue?vue&type=script&lang=js&"
import style0 from "./ArrowButton.vue?vue&type=style&index=0&id=90795f10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90795f10",
  null
  
)

export default component.exports